import React from "react";
import ReactDOM from "react-dom";
import {
	fetchChatData,
	fetchConversationData,
	submitMessage,
	chatRoomOpened,
	fetchConversationDataSuccess,
	updateSelectedDmId,
	updateSelectedUserId,
	submitRemoveDm,
	submitRemoveConversation
} from "../../actions/chatAction";
import { connect } from "react-redux";
import PeopleItem from "./components/PeopleItem";
import ChatItem from "./components/ChatItem";
import SearchUser from "./components/SearchUser";
import { isEmpty } from "lodash/fp";
import "./Chat.css";

class Chat extends React.Component {
	constructor() {
		super();

		this.state = {
			text: ""
		};

		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.handleSelectSearchUser = this.handleSelectSearchUser.bind(this);
		this.handleRefreshConversation = this.handleRefreshConversation.bind(this);
		this.handleRemoveConversationClick = this.handleRemoveConversationClick.bind(
			this
		);
	}

	handlePeopleItemClick(dmId) {
		if (this.props.selectedDmId !== dmId) {
			this.props.dispatch(updateSelectedDmId(dmId));
			this.props.dispatch(fetchConversationData(dmId));
		}
	}

	handleRemovePeopleItemClick(dmId) {
		const isConfirmed = window.confirm(
			"Are you sure want to delete this chat?"
		);

		if (isConfirmed) {
			this.props.dispatch(submitRemoveDm(dmId));
			this.props.dispatch(chatRoomOpened(false));
		}
	}

	handleRemoveConversationClick(conversationId, dmId) {
		const isConfirmed = window.confirm(
			"Are you sure want to delete this message?"
		);

		if (isConfirmed) {
			this.props.dispatch(submitRemoveConversation(conversationId, dmId));
			this.props.dispatch(chatRoomOpened(true));
		}
	}

	handleSendMessage() {
		const type = this.props.dataConversation.length === 0 ? "ADDNEW" : "ANSWER";

		this.props.dispatch(
			submitMessage({
				type,
				text: this.state.text,
				dmId: this.props.selectedDmId,
				userId: this.props.selectedUserId
			})
		);
	}

	handleSelectSearchUser(userId) {
		const findInList = this.props.dataChat.find(item => {
			return item.penerima.customer_id === userId;
		});

		if (isEmpty(findInList)) {
			this.props.dispatch(updateSelectedDmId(null));
			this.props.dispatch(updateSelectedUserId(userId));
			this.props.dispatch(fetchConversationDataSuccess([]));
			this.props.dispatch(chatRoomOpened(true));
		} else {
			this.handlePeopleItemClick(findInList.dm_id);
		}
	}

	handleRefreshConversation(dmId) {
		this.props.dispatch(fetchConversationData(dmId));
	}

	componentDidMount() {
		this.props.dispatch(fetchChatData());
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.dataConversation !== this.props.dataConversation) {
			this.setState({ text: "" });
		}
	}

	render() {
		return (
			<div className="card">
				<div className="card-body">
					{this.props.isLoading ? (
						<span>Loading...</span>
					) : this.props.isError ? (
						<div style={{ marginTop: "20px" }}>
							<i>{this.props.errorMessage}</i>
						</div>
					) : (
						<div className="container-fluid" style={{ paddingBottom: 20 }}>
							<div className="row" style={{ marginTop: "20px" }}>
								<div className="col-md-4" style={{ backgroundColor: "#FFF" }}>
									<SearchUser handleClick={this.handleSelectSearchUser} />

									<div
										className="friend-list-wrapper"
										style={{ marginTop: "10px" }}
									>
										<ul className="friend-list">
											{this.props.dataChat.map((item, i) => (
												<PeopleItem
													key={`peopleItem-${i}`}
													info={item}
													onClick={() => this.handlePeopleItemClick(item.dm_id)}
													onRemoveClick={() =>
														this.handleRemovePeopleItemClick(item.dm_id)
													}
													isActive={this.props.selectedDmId === item.dm_id}
												/>
											))}
										</ul>
									</div>
								</div>

								{this.props.isConversationLoading ? (
									<div className="col-md-8">
										<span>Loading ...</span>
									</div>
								) : this.props.chatRoomOpened ? (
									<div className="col-md-8" style={{ background: "#f9f9f9" }}>
										<div
											className="chat-message"
											ref={e => {
												if (e !== null) {
													e.scrollTop = e.scrollHeight;
												}
											}}
										>
											{this.props.dataConversation.length > 0 ? (
												<ul className="chat">
													{this.props.dataConversation.map((item, i) => (
														<ChatItem
															position={
																item.customer_id ===
																parseInt(this.props.user_id, 10)
																	? "right"
																	: "left"
															}
															key={`message-item-${i}`}
															data={item}
															handleRemove={this.handleRemoveConversationClick}
														/>
													))}
												</ul>
											) : (
												<div>Say hello :)</div>
											)}
										</div>
										<textarea
											className="form-control"
											style={{ minHeight: 60, paddingLeft: 10 }}
											value={this.state.text}
											onChange={e => this.setState({ text: e.target.value })}
										/>
										<button
											className="btn btn-success no-rounded pull-right"
											type="button"
											style={{ marginTop: "10px" }}
											onClick={this.handleSendMessage}
											disabled={this.props.isBtnLoading}
										>
											{this.props.isBtnLoading ? (
												"Loading ..."
											) : (
												<span>
													<i className="fa fa-paper-plane" /> Send Message
												</span>
											)}
										</button>
										<button
											className="btn btn-primary no-rounded pull-right"
											type="button"
											style={{ marginTop: "10px", marginRight: "5px" }}
											onClick={() =>
												this.handleRefreshConversation(this.props.selectedDmId)
											}
										>
											{this.props.isBtnLoading ? (
												"Loading ..."
											) : (
												<span>
													<i className="fa fa-refresh" /> Refresh Message
												</span>
											)}
										</button>
									</div>
								) : (
									<div className="col-md-8 chat-message">
										<div className="chat-no-message">
											<i
												className="fa fa-comments fa-3x"
												style={{ marginBottom: 10 }}
											/>{" "}
											<br /> No Selected Chat
										</div>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	errorMessage: state.chatReducer.errorMessage,
	isLoading: state.chatReducer.isLoading,
	isBtnLoading: state.chatReducer.isBtnLoading,
	dataChat: state.chatReducer.dataChat,
	dataConversation: state.chatReducer.dataConversation,
	isConversationLoading: state.chatReducer.isConversationLoading,
	chatRoomOpened: state.chatReducer.chatRoomOpened,
	selectedDmId: state.chatReducer.selectedDmId,
	selectedUserId: state.chatReducer.selectedUserId,
	user_id: state.authReducer.user_id
});

export default connect(mapStateToProps)(Chat);



// WEBPACK FOOTER //
// ./src/views/Chat/Chat.js